export default "__VITE_ASSET__b18eec8d__"